<template>
  <Head :title="__('impressum.meta.title')">
    <meta
      name="description"
      :content="__('impressum.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.impressum')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="contact-hero py-20 relative overflow-hidden">
    <img
      src="/frontend/assets/mobile-hero-swirl.svg"
      class="absolute top-0 left-0 lg:hidden"
    >
    <img
      src="/frontend/assets/desktop-hero-swirl.svg"
      class="absolute top-0 left-0 hidden lg:block"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          {{ __('impressum.title') }}
        </h1>

        <p class="text-gray-400 mt-2 lg:text-xl mb-0 lg:w-3/5 lg:mx-auto">
          {{ __('impressum.text') }}
        </p>
      </div>
    </div>
  </section>

  <section class="contact py-10 md:py-20 bg-white overflow-hidden relative">
    <img
      src="/frontend/assets/scribble-round-desktop.svg"
      class="hidden lg:block absolute left-0 top-[500px]"
    >

    <div class="container">
      {{ __('impressum.content') }}
    </div>
  </section>
</template>

<script>
export default {
};
</script>
